import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Footer from "components/footers/FourColumnWithInputForm.js";
import Header from "./../components/headers/HeaderLight"
import { css } from "styled-components/macro"; //eslint-disable-line
import AmenitiesForm from "components/forms/AmenitiesForm.js";


export default function NewAmenityPage() {

    return (
        <AnimationRevealPage>
            <Header />
            <AmenitiesForm />
            <Footer />
        </AnimationRevealPage>
    );
}
